import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Steps from "./Steps";
import { ROUTE_HOME } from "../../../shared/constants";
import Modal from "../../../../shared/Modal/Modal";
import { createOffer, updateOffer, getBanks } from "../../../shared/requests-api";
import {
	getUserToken,
	formatDateToPortugueseFormatWithTime,
	getMobileOperatingSystem,
	fidelityHasAverage
} from "../../../shared/utils";
import { refreshOffers, createOrUpdateOffer, receiveBanks, sendingOffer } from "../../../actions";
import Loading from "../../../../shared/Loading/Loading";
import { isMobile } from "./../../../../../js/components/searchform/utils/common";
import { NavLink } from "react-router-dom";
import { intFormat, formatCurrency } from "../../../../../js/shared/utils";
import {
	getUserBank,
	getUserCreditCard,
	hasBank,
	hasCreditCard
} from "./../../../shared/requests-api";
import { CreditCardsRelation } from "./../../../shared/enums";
import { ROUTE_ACCOUNT_DETAILS } from "./../../../shared/constants";
import Button from "../../../../shared/button/button";

let waitRequests = 0;
class FinishedOffer extends Component {
	constructor() {
		super();
		this.state = {};
		this.sendOffer = this.sendOffer.bind(this);
		this.sent = false;
	}

	componentDidMount() {
		this.sendOffer(this.props);
		let self = this;
		let token = getUserToken();

		waitRequests = 2;
		this.setState({ loading: true }); // aparecer loading

		localStorage.setItem("editBankSelected", "0");
		localStorage.setItem("editCardSelected", "0");

		getBanks(token)
			.then(response => {
				let banks = response.data;
				let banksMap = banks.map(bank => {
					return { idBank: bank.idBank, name: bank.name };
				});
				getUserBank(token)
					.then(response => {
						waitRequests--;
						const { bankId, agency, dacAgency, account, dacAccount, cpfcnpj } = response.data;
						let bankName = banksMap.find(bank => bank.idBank == bankId);
						self.setState({
							bankId,
							bankName: bankName.name,
							agency,
							dacAgency,
							account,
							dacAccount,
							cpfcnpj
						});
					})
					.catch(res => {
						waitRequests--;
						self.setState({ hasBank: false });
					});
			})
			.catch(err => {
				waitRequests--;
				self.setState({ hasBank: false });
			});

		getUserCreditCard(token)
			.then(response => {
				waitRequests--;
				const { name, number, validDate, securityCode, brand, cpf } = response.data;
				self.setState({
					cpf,
					cardName: name,
					number: "**** **** **** " + number,
					validDate,
					securityCode,
					card: CreditCardsRelation[brand]
				});
			})
			.catch(response => {
				waitRequests--;
				self.setState({ hasCreditCard: false });
			});
	}

	tabEditHandle(tab) {
		if (tab == "bank") {
			localStorage.setItem("editBankSelected", "1");
		} else if (tab == "card") {
			localStorage.setItem("editCardSelected", "1");
		}
	}

	componentWillReceiveProps(nextProps) {
		this.sendOffer(nextProps);
	}

	sendOffer(props) {
		const { form, createOrUpdateOffer } = props;
		const self = this;

		if (form && !this.sent) {
			this.sent = true;

			localStorage.removeItem("CreateOffer");

			const { offer } = this.props;
			const {
				quantMiles,
				price,
				averageMiles,
				login,
				password,
				phone,
				/*device,
				email,*/
				rescuePassword,
				fidelityId,
				fidelity,
				reducao
			} = form;
			let found;
			let update = fidelity.offerId || offer;
			let id = update ? fidelity.offerId || offer.id : fidelityId;
			let average = averageMiles || fidelity.averageMiles;
			let reductions = undefined;
			if (fidelity.isSmilesDiamond) {
				if (quantMiles >= 35000 && quantMiles < 60000) {
					reductions = 1;
				} else if (quantMiles >= 60000 && reducao) {
					reductions = reducao.value;
				} else {
					reductions = 0;
				}
			}

			let oldAverage = average;

			if (average && (average > quantMiles || quantMiles < 60000)) {
				average = 3500;
			} else {
				average = parseInt(average / 500) * 500; // OFW-396
			}

			this.setState({
				averageMiles: average,
				showAverageDifference: average != oldAverage
			});

			createOrUpdateOffer(
				update,
				id,
				fidelityId,
				quantMiles,
				price,
				String(login),
				String(password),
				phone !== undefined ? String(phone) : phone,
				average,
				/*device,
				email,*/
				String(rescuePassword),
				reductions,
				form
			);
		}
	}

	render() {
		const { prev, form, sending, successSend, showSendModal, sendingOffer } = this.props;
		const {
			step,
			cardName,
			number,
			cpf,
			bankName,
			agency,
			dacAgency,
			account,
			dacAccount,
			showAverageDifference,
			averageMiles
		} = this.state;

		let block,
			showMedia =
				fidelityHasAverage(form.fidelityId) &&
				averageMiles >= form.fidelity.valMinMiles &&
				form.quantMiles >= 60000;

		if (sending || waitRequests > 0) {
			block = <Loading label="Cadastrando oferta..." />;
		} else {
			sendingOffer(false, successSend, false);
			block = (
				<div>
					<div className="col-xs-16 finished-offer--app-banner">
						<div className="col-xs-16 col-md-8 text-hide finished-offer--app-banner-text" />
						{isMobile() &&
						(getMobileOperatingSystem() == "Android" || getMobileOperatingSystem() == "iOS") ? (
							<div className="col-xs-16 text-left no-padding finished-offer--app-banner-button-place">
								<a
									className="btn btn-success"
									target="_blank"
									href={
										getMobileOperatingSystem() == "Android"
											? "https://play.google.com/store/apps/details?id=br.com.maxmilhas"
											: "https://itunes.apple.com/br/app/maxmilhas/id1117404560"
									}
									data-action="finished-offer-app-download"
								>
									Baixe nosso App
								</a>
							</div>
						) : (
							<div className="col-xs-16 col-md-4 app-download no-padding no-margin">
								<div className="store-badge">
									<a
										target="_blank"
										className="google-play text-hide"
										href="https://play.google.com/store/apps/details?id=br.com.maxmilhas"
										data-action="finished-offer-app-download-google-play"
									>
										Google Play
									</a>
									<a
										target="_blank"
										className="app-store text-hide"
										href="https://itunes.apple.com/br/app/maxmilhas/id1117404560"
										data-action="finished-offer-app-download-app-store"
									>
										App Store
									</a>
								</div>
							</div>
						)}
					</div>
					<div className="visible-print finished-offer--logo">
						<div className="print-logo-mm" />
					</div>
					<div className="col-xs-16 text-center finished-offer--info ">
						{successSend ? (
							<React.Fragment>
								<p className="finished-offer--info-success-text">
									<strong>Oferta cadastrada {isMobile() ? <br /> : ""}com sucesso!</strong>
								</p>
								<p>
									Sua oferta será analisada pela {isMobile() ? <br /> : ""}nossa equipe em até dois
									dias úteis.
								</p>
							</React.Fragment>
						) : null}
						{!successSend ? (
							<React.Fragment>
								<p className="finished-offer--info-error-text">
									<strong>Ocorreu um erro {isMobile() ? <br /> : ""}ao cadastrar oferta.</strong>
								</p>
								<p>Tente novamente ou entre {isMobile() ? <br /> : ""}em contato com a gente.</p>
							</React.Fragment>
						) : null}
						<p className="finished-offer--info-myoffers-link">
							<NavLink
								to={`${ROUTE_HOME}`}
								className="btn btn-success"
								data-action="finished-offer-home"
							>
								Ir para minhas ofertas <i className="icon-double-right" />
							</NavLink>
						</p>
					</div>
					<div className="col-xs-16 finished-offer--details">
						<div className="hidden-print finished-offer--details--icon">
							<i className={successSend ? `icon-check` : `icon-close`} />
						</div>
						<div className="row pb-15">
							<div className="col-xs-16 col-print-6 col-md-8 text-left">
								<p>
									<span className="finished-offer--details-fidelity-name">
										{form.fidelity.name}
									</span>{" "}
									{isMobile() ? (
										<span>
											<br />
											{form.fidelity.label}
										</span>
									) : (
										`- ${form.fidelity.label} `
									)}
								</p>
							</div>
							<div
								className={`col-xs-16 col-print-6 col-md-8 text-${
									isMobile() ? "left" : "right"
								} finished-offer--details-date`}
							>
								<p className="field-name">
									Cadastrada em:{" "}
									<strong>
										{successSend ? formatDateToPortugueseFormatWithTime(new Date()) : "-"}
									</strong>
								</p>
							</div>
						</div>
						{/*<div className="col-xs-3 col-md-8 text-right finished-offer--details-right">PDF</div>*/}
						<div className="col-xs-16 offers-divider offers-divider--title" />
						<div className="row">
							<div className="col-xs-16 col-print-6 col-md-8 text-left finished-offer--details-miles-info v-center-columns">
								<p>
									<strong>{intFormat(form.quantMiles)} milhas</strong>
								</p>
								<p className={`${showMedia || isMobile() ? "" : "no-margin"}`}>
									1.000 milhas: <strong>{formatCurrency(form.price)}</strong>
								</p>
								{showMedia ? (
									<p className={isMobile() ? "" : "no-margin"}>
										Média:{" "}
										<strong>
											{intFormat(averageMiles)} milhas{" "}
											{isMobile() ? (
												<span>
													<br />por passageiro
												</span>
											) : (
												"por passageiro"
											)}
										</strong>
										{showAverageDifference ? (
											<i
												className="tooltip gray"
												data-tooltip="Sua média foi arredondada para múltiplos de 500."
												data-flow="up"
											>
												?
											</i>
										) : null}
									</p>
								) : null}
							</div>
							<div className="col-xs-16 col-print-6 col-md-8 text-center v-center-columns">
								<div className="finished-offer--details-box-total">
									<p className="value-to-receive-label">
										Valor a receber caso {isMobile() ? <br /> : null} venda todas as milhas
									</p>
									<p className="value-to-receive">
										<strong>
											{formatCurrency((form.price || 0) * (form.quantMiles || 0) / 1000)}
										</strong>
									</p>
								</div>
							</div>
						</div>
						<div className="col-xs-16 offers-divider" />
						<div className="col-xs-10 col-print-4 col-md-4 text-left finished-offer--details-bank finished-offer--details-left">
							<p className="field-name">Banco:</p>
							<p className={isMobile() ? "" : "no-margin"}>
								<strong>{bankName}</strong>
							</p>
						</div>
						<div className="hidden-print col-xs-6 hidden-md hidden-lg text-right finished-offer--details-bank finished-offer--details-right">
							<ul>
								<li>
									<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
										<div
											onClick={() => this.tabEditHandle("bank")}
											data-action="finished-offer-edit-bank"
										>
											<i className="icon-edit" />
										</div>
									</NavLink>
								</li>
							</ul>
						</div>
						<div className="col-xs-16 col-print-4 col-md-4 text-left finished-offer--details-bank">
							<p className="field-name">Agência:</p>
							<p className={isMobile() ? "" : "no-margin"}>
								<strong>
									{agency}
									{dacAgency ? "-" + dacAgency : ""}
								</strong>
							</p>
						</div>
						<div className="col-xs-16 col-print-4 col-md-4 text-left finished-offer--details-bank">
							<p className="field-name">Conta:</p>
							<p className="no-margin">
								<strong>
									{account}-{dacAccount}
								</strong>
							</p>
						</div>
						<div className="hidden-print col-md-4 hidden-xs hidden-sm text-right finished-offer--details-bank finished-offer--details-right">
							<ul>
								<li>
									<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
										<div
											onClick={() => this.tabEditHandle("bank")}
											data-action="finished-offer-edit-bank"
										>
											<i className="icon-edit" />
										</div>
									</NavLink>
								</li>
							</ul>
						</div>
						<div className="col-xs-16 offers-divider" />
						{number ? (
							<React.Fragment>
								<div className="col-xs-10 col-print-4 col-md-4 text-left finished-offer--details-card finished-offer--details-left">
									<p className="field-name">Número do cartão:</p>
									<p className={isMobile() ? "" : "no-margin"}>
										<strong>{number}</strong>
									</p>
								</div>
								<div className="hidden-print col-xs-6 hidden-md hidden-lg text-right finished-offer--details-card finished-offer--details-right">
									<ul>
										<li>
											<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
												<div
													onClick={() => this.tabEditHandle("card")}
													data-action="finished-offer-edit-card"
												>
													<i className="icon-edit" />
												</div>
											</NavLink>
										</li>
									</ul>
								</div>
								<div className="col-xs-16 col-print-4 col-md-4 text-left finished-offer--details-card">
									<p className="field-name">CPF/CNPJ:</p>
									<p className={isMobile() ? "" : "no-margin"}>
										<strong>{cpf}</strong>
									</p>
								</div>
								<div className="col-xs-16 col-print-4 col-md-4 text-left finished-offer--details-card">
									<p className="field-name">Nome:</p>
									<p className="no-margin">
										<strong>{cardName}</strong>
									</p>
								</div>
							</React.Fragment>
						) : (
							<React.Fragment>
								<div className="col-xs-10 col-print-14 col-md-12 text-left finished-offer--details-card finished-offer--details-left">
									<p className="field-name">Número do cartão:</p>
									<p className={isMobile() ? "hidden-print" : "hidden-print no-margin"}>
										<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
											<span
												onClick={() => this.tabEditHandle("card")}
												data-action="finished-offer-edit-card"
											>
												Clique aqui
											</span>
										</NavLink>{" "}
										para cadastrar um cartão{isMobile() ? <br /> : ""} de crédito.
									</p>
								</div>
								<div className="hidden-print col-xs-6 hidden-md hidden-lg text-right finished-offer--details-card finished-offer--details-right">
									<ul>
										<li className="hidden-print">
											<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
												<div
													onClick={() => this.tabEditHandle("card")}
													data-action="finished-offer-edit-card"
												>
													<i className="icon-edit" />
												</div>
											</NavLink>
										</li>
									</ul>
								</div>
							</React.Fragment>
						)}
						<div className="hidden-print col-md-4 hidden-xs hidden-sm text-right finished-offer--details-card finished-offer--details-right">
							<ul>
								<li>
									<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
										<div
											onClick={() => this.tabEditHandle("card")}
											data-action="finished-offer-edit-card"
										>
											<i className="icon-edit" />
										</div>
									</NavLink>
								</li>
							</ul>
						</div>
						{/*<div className="col-xs-16 col-md-8 text-right finished-offer--details-ip finished-offer--details-right">
							<p className="field-name">
								IP: <strong>000.000.000.000</strong>
							</p>
						</div>*/}
					</div>
					<div className="col-xs-16 hidden-print finished-offer--details-date--print">
						<Button
							className="btn btn-xs btn-success btn-finish-print"
							onClick={() => window.print()}
						>
							Imprimir
						</Button>
					</div>
				</div>
			);
		}

		return (
			<section className="finished-offer row no-margin">
				<div className="finished-offer--container form-offer block-center">{block}</div>
			</section>
		);
	}
}

const mapStateToProps = state => ({
	sending: state.offers.sending,
	successSend: state.offers.successSend,
	showSendModal: state.offers.showSendModal
});

const mapDispatchToProps = dispatch => {
	return {
		refreshOffers: () => dispatch(refreshOffers()),
		sendingOffer: (sending, success, show) => dispatch(sendingOffer(sending, success, show)),
		createOrUpdateOffer: (
			update,
			id,
			idFidelity,
			quant,
			price,
			login,
			password,
			phone,
			averageMiles,
			/*device,
			email,*/
			pwAwardSecondary,
			reductions,
			form
		) =>
			dispatch(
				createOrUpdateOffer(
					update,
					id,
					idFidelity,
					quant,
					price,
					login,
					password,
					phone,
					averageMiles,
					/*device,
					email,*/
					pwAwardSecondary,
					reductions,
					form
				)
			)
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FinishedOffer));
